import React, { useEffect, useState, useReducer } from "react";
import { Popup, Position } from "devextreme-react/popup";
import SelectBox from "devextreme-react/select-box";
import { NumberBox } from "devextreme-react/number-box";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import ScrollView from "devextreme-react/scroll-view";
import Button from "devextreme-react/button";
import { Toast } from "devextreme-react/toast";
import Tabs from "devextreme-react/tabs";
import NEXUS_CONST from "../../common/constants";
import TextBox from "devextreme-react/text-box";
import moment from "moment";
import { alert } from "devextreme/ui/dialog";
import DateBox from "devextreme-react/date-box";
import { Validator, RequiredRule } from "devextreme-react/validator";
import { postUserLog } from "../../actions/common";
import MaterialAddition from "./MaterialAddition";
import DataGrid, {
  Column,
  Lookup,
  HeaderFilter,
  Editing,
  Scrolling,
  Paging,
  Pager,
  Button as Button1,
} from "devextreme-react/data-grid";
import config from "../../common/config";
const initialState = {
  shiftDetails: null,
  errorInfo: null,
  shiftListData: [],
  shiftDeleteInfo: null,
  siteInfo: null,
};

export default ({ closeShift, siteId, tierId, tierName, parentTier }) => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  let { shiftDetails, errorInfo, shiftListData, shiftDeleteInfo, siteInfo } =
    state;
  const [showShift, setShowShift] = useState(true);
  const [qty, setQty] = useState(1);
  const [duration, setDuration] = useState(8);
  const [target, setTarget] = useState(8);
  const [maxDue, setMaxDuration] = useState(8);
  const [dleTarget, setDleTarget] = useState(0);
  const [fpyTarget, setFPYTarget] = useState(0);
  const [saTarget, setSaTarget] = useState(0);
  const [ophTarget, setophTarget] = useState(0);
  const [shifts, setShifts] = useState([]);
  const [shiftData, setShiftData] = useState(null);
  const [timeList, setTimeList] = useState([]);
  const [startTime, setStartTime] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabHeader, setactiveTabHeader] = useState("tab1");
  const [nSDate, setNSDate] = useState(moment(new Date()).add(1, "days"));
  const [nSEndDate, setNSEndDate] = useState(moment(new Date()).add(1, "days"));
  const [minDate, setMinDate] = useState(moment(new Date()).add(1, "days"));

  const dispKey = { i: "DDMMYYYY h:m A", d: "h-m-A" };
  const INTERVALS = { shift: 4, break: 15 };
  //const updateShiftInfo = d => dispatch({ type: 'FETCH_SHIFT_LIST', payload: d });

  const [activeShiftData, setActiveShiftData] = useState(null);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const isAutoOph =
    NEXUS_CONST.ENV !== "production" &&
    NEXUS_CONST.L_SERIES.indexOf(tierId) > -1;

  const [tabs, setTabsLst] = useState(
    isAutoOph
      ? [
          {
            id: 3,
            text: "Shift Summary",
          },
          {
            id: 1,
            text: "Standard Production Day",
          },
          {
            id: 2,
            text: "Non-Standard Production Day",
            disabled: true,
          },
        ]
      : [
          {
            id: 3,
            text: "Shift Summary",
          },
          {
            id: 1,
            text: "Standard Production Day",
          },
          {
            id: 2,
            text: "Non-Standard Production Day",
          },
        ]
  );

  const onRowRemoved = (data) => {
    actions.deleteShiftInfo(dispatch, data.data.tierShiftID, tierId);
  };

  const onEditShiftInfo = (e) => {
    setNSDate(e.data.date);
    setActiveTab(e.data.shiftType == "Standard" ? 1 : 2);
    setActiveShiftData(e.data);
  };
  useEffect(() => {
    actions.getSiteInfo(dispatch, `siteid=${siteId}&tierid=${tierId}`);
  }, []);

  useEffect(() => {
    if (shiftDeleteInfo && shiftDeleteInfo.code == 1) {
      alert(shiftDeleteInfo.message);
    }
  }, [shiftDeleteInfo]);

  useEffect(() => {
    if (siteInfo && siteInfo.lastUpdatedDate) {
      setNSDate(
        moment(siteInfo.lastUpdatedDate, "YYYY-MM-DD HH:mm").add(24, "hours")
      );
      setMinDate(
        moment(siteInfo.lastUpdatedDate, "YYYY-MM-DD HH:mm").add(24, "hours")
      );
    }
  }, [siteInfo]);

  let [hourChange, setHourChange] = useState([]);

  useEffect(() => {
    if (shiftDetails) {
      setDleTarget(shiftDetails.dleTarget ? shiftDetails.dleTarget : 0);
      setFPYTarget(shiftDetails.fpyTarget ? shiftDetails.fpyTarget : 0);
      setSaTarget(shiftDetails.saTarget ? shiftDetails.saTarget : 0);
      setophTarget(shiftDetails.ophTarget ? shiftDetails.ophTarget : 0);

      if (shiftDetails.shift) {
        setShifts(shiftDetails.shift);
      }

      if (shiftDetails.endDate) {
        setNSEndDate(shiftDetails.endDate);
      }
    }
  }, [shiftDetails]);

  useEffect(() => {
    if (errorInfo && errorInfo == "24") {
      alert(" Total hours of all shifts should not exceed 24 hours.", "Alert");
    }

    if (errorInfo && errorInfo == "overlap") {
      alert(
        "Shift should not have overlapping time. Please check and update the shift timings.",
        "Alert"
      );
    }
    if (errorInfo && errorInfo == "breakOutRange") {
      alert(
        "All break times should be within the shift timings and break end time should be greater than to break start time.  Please check the break times and update.",
        "Alert"
      );
    }
    if (errorInfo && errorInfo == "breakOverlap") {
      alert(
        "Break should not have overlapping time. Please check and update the break timings.",
        "Alert"
      );
    }
    if (errorInfo && errorInfo == "dateValidation") {
      alert(
        "There is already a non standard shift schedule assigned for the selected dates. Please review your date selection.",
        "Alert"
      );
    }
    if (errorInfo && errorInfo == "saved") {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "success",
        message: "Shift details saved!",
      });
    }
  }, [errorInfo]);

  const validateTimes = () => {
    let isValid = true;
    let shiftEndTimeErr = [];
    let breakErr = [];
    shifts.map((shift, i) => {
      if (!isValidEndTime(i)) {
        shiftEndTimeErr.push(shift.name);
        isValid = false;
      } else {
        if (shift.breakInfo.length > 0) {
          shift.breakInfo.map((brk, j) => {
            if (
              !isValidBreakTime({
                type: "st",
                val: brk["startTime"],
                sI: i,
                bI: j,
              })
            ) {
              isValid = false;
              breakErr.push(shift.name);
            }
            if (
              !isValidBreakTime({
                type: "et",
                val: brk["endTime"],
                sI: i,
                bI: j,
              })
            ) {
              isValid = false;
              breakErr.push(shift.name);
            }
          });
        }
      }
    });
    let msg = "";
    if (!isValid) {
      if (shiftEndTimeErr.length > 0) {
        msg = `The shift end time must be greater than shift start time .(<b>${shiftEndTimeErr.toString()}</b>)`;
      }
      if (breakErr.length > 0) {
        msg =
          msg +
          `<br /> The hour and minutes of the break time must be within the shift timing.(<b>${[
            ...new Set(breakErr),
          ].toString()}</b>)`;
      }
      alert(msg, "Alert");
    }

    return isValid;
  };

  const validateOverLapShift = () => {
    let isValid = true;
    let _Shifts = [...shifts];
    if (_Shifts.length > 1) {
      _Shifts.map((shift, i) => {
        if (i > 0) {
          let { h, m, mer } = shift.startTime;
          let et = shift.endTime;
          let curSt = moment(`11112011 ${h}:${m} ${mer}`, dispKey.i);
          let curEt = moment(`11112011 ${et.h}:${et.m} ${et.mer}`, dispKey.i);
          let pSt = _Shifts[i - 1].startTime;
          let pEt = _Shifts[i - 1].endTime;
          let prevSt = moment(
            `11112011 ${pSt.h}:${pSt.m} ${pSt.mer}`,
            dispKey.i
          );
          let prevEt = moment(
            `11112011 ${pEt.h}:${pEt.m} ${pEt.mer}`,
            dispKey.i
          );
          if (curSt < prevEt) {
            isValid = false;
          }
        }
      });
    }
    return isValid;
  };

  const validateBreaks = () => {
    let isValid = true;
    shifts.map((shift, i) => {
      if (shift.breakInfo.length > 0) {
        shift.breakInfo.map((brk, j) => {
          if (!brk.type || brk.type == "") isValid = false;
        });
      }
    });
    if (!isValid)
      alert(
        "Break type should not be empty. Please enter the value for Break Type in all breaks.",
        "Alert"
      );
    return isValid;
  };

  const getHVal = (v) => {
    if (v <= 12) return v;
    else return getHVal(v - 12);
  };

  const userLog = (val, type) => {
    if (shiftDetails) {
      let saveType = "Update";
      let actType = "updated";
      if (!shiftDetails.tierId) {
        saveType = "Create";
        actType = "set";
      }
      let fieldName = "";
      switch (type) {
        case "dleTarget":
          if (shiftDetails.dleTarget != val) fieldName = "DLE";
          break;
        case "fpyTarget":
          if (shiftDetails.fpyTarget != val) fieldName = "FPY";
          break;
        case "saTarget":
          if (shiftDetails.saTarget != val) fieldName = "Sch. Attainment";
          break;
        case "ophTarget":
          if (shiftDetails.ophTarget != val) fieldName = "OPH Attainment";
          break;
      }

      let evnt = "Shift Schedule " + saveType;
      let shftTyp = activeTab == "1" ? "SPD" : "NSPD";
      if (fieldName) {
        postUserLog({
          event: evnt,
          data: {
            action: `${shftTyp} ${fieldName} Target (%) ${actType}`,
            module: "Settings",
            section: "Manage Tier",
            siteUId: siteId,
            widget: "",
            tierId: `${tierId}`,
          },
        });
      }
    }
  };
  
  const saveShiftInfo = () => {
    /*
      if (!validateTimes()) {
        return false;
      }
      */
    if (!validateBreaks()) {
      return false;
    }
    if (activeTab == 2 && moment(nSEndDate) < moment(nSDate)) {
      alert("End date must be greater or equal to State date.", "Alert");
      return false;
    }

    if (
      activeTab == 1 &&
      (dleTarget > 0 || fpyTarget > 0 || saTarget > 0 || ophTarget > 0) &&
      shifts.length == 0
    ) {
      alert(
        "Please add a shift to save the non-zero values for DLE Target or FPY Target or Sch. Attainment Target",
        "Alert"
      );
      return false;
    }

    /*if (!validateOverLapShift()) {
      alert(
        "Shift should not have overlapping time. Please check and update the shift timings.",
        "Alert"
      );
      return false;
      }
      */

    let payload = {};
    payload["qty"] = shifts.length;
    payload["tierShiftId"] = shiftDetails.tierShiftId
      ? shiftDetails.tierShiftId
      : 0;
    payload["shift"] = shifts;
    payload["tierId"] = tierId;
    payload["dleTarget"] = dleTarget;
    payload["fpyTarget"] = fpyTarget;
    payload["saTarget"] = saTarget;
    payload["ophTarget"] = ophTarget;

    if (activeTab == 1) payload["isStdDay"] = true;
    if (activeTab == 2) payload["isStdDay"] = false;
    if (activeTab == 2) {
      payload["stdNonStdStartDate"] = moment(nSDate).format("YYYY-MM-DD");
      payload["stdNonStdEndDate"] = moment(nSEndDate).format("YYYY-MM-DD");
    }
    let shiftType = payload["isStdDay"] ? 1 : 2;
    actions.manageShifts(
      dispatch,
      payload,
      `${tierId}&shiftType=${shiftType}&date=` +
        moment(nSDate).format("YYYY-MM-DD")
    );
  };

  const logShftUpdate = (sI) => {
    let shftType = activeTab == "1" ? "SPD" : "NSPD";
    postUserLog({
      event: "Shift Schedule Update",
      data: {
        action:
          shftType +
          " " +
          shifts[sI]["name"] +
          " start time & end time updated",
        module: "Settings",
        section: "Manage Tier",
        siteUId: siteId,
        widget: "",
        tierId: `${tierId}`,
      },
    });
  };

  const logBrkUpdate = (sI, bI) => {
    let shftType = activeTab == "1" ? "SPD" : "NSPD";
    let brkData = shifts[sI]["breakInfo"][bI];
    let brkTyp = brkData.type ? brkData.type : "";
    postUserLog({
      event: "Shift Schedule Update",
      data: {
        action:
          shftType +
          " " +
          shifts[sI]["name"] +
          " - Break updated in " +
          brkData.startTime.h +
          ":" +
          brkData.startTime.m +
          " " +
          brkData.startTime.mer +
          " - " +
          brkData.endTime.h +
          ":" +
          brkData.endTime.m +
          " " +
          brkData.endTime.mer +
          " as " +
          brkTyp,
        module: "Settings",
        section: "Manage Tier",
        siteUId: siteId,
        widget: "",
        tierId: `${tierId}`,
      },
    });
  };

  const onTabChange = (e) => {
    if (e.name === "selectedIndex") {
      setShifts([]);
      setActiveShiftData(null);
      setNSEndDate(minDate);
      setNSDate(minDate);
      setActiveTab(e.value);
      postUserLog({
        event: "Shift Schedule",
        data: {
          action: tabs[e.value].text.toString() + " Selected",
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          widget: "",
          tierId: `${tierId}`,
        },
      });
    }
  };

  const getEndTime = (d, gap, unit) => {
    let { h, m, mer } = d;
    let obj = moment(`11112011 ${h}:${m} ${mer}`, dispKey.i);
    let time = obj.add(gap, unit).format(dispKey.d).split("-");
    return { h: parseInt(time[0]), m: parseInt(time[1]), mer: time[2] };
  };

  const addShift = () => {
    let shiftName = "Shift 1";
    let _shifts = [...shifts];
    let SLen = _shifts.length;
    if (SLen > 0) {
      let last = _shifts[SLen - 1];
      let timeInfo = getEndTime(last.endTime, INTERVALS.shift, "h");
      let { h, m, mer } = last.endTime;
      _shifts.push({
        startTime: { h: h, m: m, mer: mer },
        endTime: timeInfo,
        breakInfo: [],
        name: "Shift " + (SLen + 1),
        id: 0,
      });
      shiftName = "Shift " + (SLen + 1);
    } else
      _shifts.push({
        startTime: { h: 9, m: 30, mer: "AM" },
        endTime: { h: 5, m: 30, mer: "PM" },
        breakInfo: [],
        name: "Shift 1",
        id: 0,
      });

    let shftType = activeTab == "1" ? "SPD" : "NSPD";
    postUserLog({
      event: "Shift Schedule Create",
      data: {
        action: shftType + " - " + shiftName + " added",
        module: "Settings",
        section: "Manage Tier",
        siteUId: siteId,
        widget: "",
        tierId: `${tierId}`,
      },
    });

    setShifts(_shifts);
  };

  const addBReaks = (sI) => {
    let _shifts = [...shifts];
    let SLen = _shifts.length;
    if (SLen > 0) {
      let _shift = _shifts[sI];
      let startTime = _shift.startTime;
      let timeInfo = getEndTime(startTime, INTERVALS.break, "minutes");
      _shifts[sI].breakInfo.push({
        startTime: { h: startTime.h, m: startTime.m, mer: startTime.mer },
        endTime: timeInfo,
      });

      let shftType = activeTab == "1" ? "SPD" : "NSPD";
      let brkTyp = "Break added in ";
      postUserLog({
        event: "Shift Schedule Create",
        data: {
          action:
            shftType +
            " " +
            shifts[sI]["name"] +
            " - " +
            brkTyp +
            startTime.h +
            ":" +
            startTime.m +
            " " +
            startTime.mer +
            " - " +
            timeInfo.h +
            ":" +
            timeInfo.m +
            " " +
            timeInfo.mer,
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          widget: "",
          tierId: `${tierId}`,
        },
      });
    }
    //else _shifts[sI].breakInfo.push({ startTime: { h: 12, m: 15, mer: 'PM' }, endTime: { h: 12, m: 30, mer: 'PM' }, type: '' })
    setShifts(_shifts);
  };

  const delBreak = (sI, bI) => {
    setShifts((prevData) => {
      return prevData.map((d, i) => {
        if (sI == i) {
          let shftType = activeTab == "1" ? "SPD" : "NSPD";
          let brkData = d["breakInfo"][bI];
          let brkTyp = brkData.type ? brkData.type : "Break";
          postUserLog({
            event: "Shift Schedule Delete",
            data: {
              action:
                shftType +
                " " +
                shifts[sI]["name"] +
                " - " +
                brkTyp +
                " deleted from " +
                brkData.startTime.h +
                ":" +
                brkData.startTime.m +
                " " +
                brkData.startTime.mer +
                " - " +
                brkData.endTime.h +
                ":" +
                brkData.endTime.m +
                " " +
                brkData.endTime.mer,
              module: "Settings",
              section: "Manage Tier",
              siteUId: siteId,
              widget: "",
              tierId: `${tierId}`,
            },
          });

          d["breakInfo"] = d["breakInfo"].filter((b, j) => j != bI);
        }
        return d;
      });
    });
  };

  const delShift = (sI, e) => {
    let shftType = activeTab == "1" ? "SPD" : "NSPD";
    postUserLog({
      event: "Shift Schedule Delete",
      data: {
        action: shftType + " - " + shifts[sI]["name"] + " deleted",
        module: "Settings",
        section: "Manage Tier",
        siteUId: siteId,
        widget: "",
        tierId: `${tierId}`,
      },
    });
    setShifts((prevInfo) => prevInfo.filter((d, i) => i != sI));
  };

  const isValidBreakTime = ({ type, val, sI, bI }) => {
    let _shifts = [...shifts];
    if (type == "st") {
      let { h, m, mer } = _shifts[sI].startTime;
      let et = _shifts[sI].endTime;
      let sSt = moment(`11112011 ${h}:${m} ${mer}`, dispKey.i);
      let sEt = moment(`11112011 ${et.h}:${et.m} ${et.mer}`, dispKey.i);

      let bSt = moment(`11112011 ${val.h}:${val.m} ${val.mer}`, dispKey.i);
      if (sSt > bSt || sEt < bSt) {
        return false;
      }
      return true;
    } else {
      let { h, m, mer } = _shifts[sI].startTime;
      let et = _shifts[sI].endTime;
      let sSt = moment(`11112011 ${h}:${m} ${mer}`, dispKey.i);
      let sEt = moment(`11112011 ${et.h}:${et.m} ${et.mer}`, dispKey.i);
      let bSt = moment(`11112011 ${val.h}:${val.m} ${val.mer}`, dispKey.i);
      if (sSt > bSt || sEt < bSt) {
        return false;
      }
      return true;
    }
  };

  const isValidEndTime = (sI) => {
    let _shifts = [...shifts];
    let { h, m, mer } = _shifts[sI].startTime;
    let et = _shifts[sI].endTime;
    let sSt = moment(`11112011 ${h}:${m} ${mer}`, dispKey.i);
    let sEt = moment(`11112011 ${et.h}:${et.m} ${et.mer}`, dispKey.i);
    if (sSt < sEt) return true;
    else {
      return false;
    }
  };

  useEffect(() => {
    if (activeTab == 0) {
      actions.fetchMatShiftList(dispatch, tierId);
    } else {
      if (siteInfo && siteInfo.lastUpdatedDate)
        actions.fetchMatShifts(
          dispatch,
          tierId +
            "&shiftType=" +
            activeTab +
            "&date=" +
            moment(nSDate).format("YYYY-MM-DD")
        );
    }
  }, [activeTab, nSDate]);

  const getPeriods = (d, j) => {
    let { h, m, mer } = d;
    let obj = moment(`11112011 ${h}:${m} ${mer}`, dispKey.i);
    return obj.add(j, "h").format(dispKey.d);
  };

  const shiftScheduler = () => {
    let _shiftList = [...shifts];
    return (
      <>
        {_shiftList &&
          _shiftList.map((data, sfhtI) => {
            return (
              <div className="shft-crd" key={sfhtI}>
                <div className="shft-del-btn" title="Delete Shift">
                  <span onClick={(e) => delShift(sfhtI, e)}>
                    <i className="dx-link dx-link-delete dx-icon-trash dx-link-icon " />{" "}
                  </span>
                  {/*<span>Delete Shift</span> */}
                </div>
                <span className="shft-n ">
                  <h3>Shift ({sfhtI + 1 + " of " + _shiftList.length}) :</h3>
                  <TextBox
                    width="150"
                    value={data.name ? data.name : "Shift " + (sfhtI + 1)}
                    onValueChanged={(e) => {
                      postUserLog({
                        event: "Shift Schedule Update",
                        data: {
                          action:
                            "Shift " + (sfhtI + 1) + " renamed to " + e.value,
                          module: "Settings",
                          section: "Manage Tier",
                          siteUId: siteId,
                          widget: "",
                          tierId: `${tierId}`,
                        },
                      });

                      setShifts((prevData) => {
                        return prevData.map((d, i) => {
                          if (sfhtI == i) {
                            d["name"] = e.value;
                          }
                          return d;
                        });
                      });
                    }}
                  />
                </span>

                <div style={{ display: "flex" }}>
                  <div className="shft-time">
                    <span className="lbl">
                      <h3>Start time:</h3>{" "}
                    </span>
                    <span className="t-crd">
                      <NumberBox
                        width="70px"
                        value={data["startTime"] ? data["startTime"]["h"] : 9}
                        min={1}
                        max={12}
                        stylingMode="outlined"
                        showSpinButtons={true}
                        className="inBlk"
                        onValueChanged={(e) => {
                          logShftUpdate(sfhtI);
                          setShifts((prevData) => {
                            return prevData.map((d, i) => {
                              if (sfhtI == i) {
                                d["startTime"]["h"] = e.value;
                              }
                              return d;
                            });
                          });
                        }}
                      />
                      <span style={{ padding: "10px 5px" }}>:</span>
                      <NumberBox
                        width="70px"
                        style={{ margin: "1px" }}
                        stylingMode="outlined"
                        className="inBlk"
                        value={
                          data["startTime"]
                            ? data["startTime"]["m"] === 0
                              ? "00"
                              : data["startTime"]["m"]
                            : 0
                        }
                        min={0}
                        max={59}
                        step={5}
                        showSpinButtons={true}
                        onValueChanged={(e) => {
                          logShftUpdate(sfhtI);
                          setShifts((prevData) => {
                            return prevData.map((d, i) => {
                              if (sfhtI == i) {
                                d["startTime"]["m"] = e.value;
                              }
                              return d;
                            });
                          });
                        }}
                      />
                      <span> </span>
                      <SelectBox
                        items={["AM", "PM"]}
                        width="70px"
                        className="inBlk"
                        value={
                          data["startTime"] ? data["startTime"]["mer"] : "AM"
                        }
                        onValueChanged={(e) => {
                          logShftUpdate(sfhtI);
                          setShifts((prevData) => {
                            return prevData.map((d, i) => {
                              if (sfhtI == i) {
                                d["startTime"]["mer"] = e.value;
                              }
                              return d;
                            });
                          });
                        }}
                      />
                    </span>
                  </div>

                  <div className="shft-time">
                    <span className="lbl">
                      <h3>End time:</h3>{" "}
                    </span>
                    <span className="t-crd">
                      <NumberBox
                        width="70px"
                        value={data["endTime"] ? data["endTime"]["h"] : 9}
                        min={1}
                        max={12}
                        stylingMode="outlined"
                        showSpinButtons={true}
                        className="inBlk"
                        onValueChanged={(e) => {
                          logShftUpdate(sfhtI);
                          setShifts((prevData) => {
                            return prevData.map((d, i) => {
                              if (sfhtI == i) {
                                d["endTime"]["h"] = e.value;
                              }
                              return d;
                            });
                          });
                        }}
                      />
                      <span style={{ padding: "10px 5px" }}>:</span>
                      <NumberBox
                        width="70px"
                        stylingMode="outlined"
                        className="inBlk"
                        value={
                          data["endTime"]
                            ? data["endTime"]["m"] === 0
                              ? "00"
                              : data["endTime"]["m"]
                            : 0
                        }
                        min={0}
                        max={59}
                        step={5}
                        showSpinButtons={true}
                        onValueChanged={(e) => {
                          logShftUpdate(sfhtI);
                          setShifts((prevData) => {
                            return prevData.map((d, i) => {
                              if (sfhtI == i) {
                                d["endTime"]["m"] = e.value;
                              }
                              return d;
                            });
                          });
                        }}
                      />
                      <span> </span>
                      <SelectBox
                        items={["AM", "PM"]}
                        width="70px"
                        className="inBlk"
                        value={data["endTime"] ? data["endTime"]["mer"] : "AM"}
                        onValueChanged={(e) => {
                          logShftUpdate(sfhtI);
                          setShifts((prevData) => {
                            return prevData.map((d, i) => {
                              if (sfhtI == i) {
                                d["endTime"]["mer"] = e.value;
                              }
                              return d;
                            });
                          });
                        }}
                      />
                    </span>
                  </div>
                </div>
                <div className="breaks">
                  <div className="shift-head-blk">
                    <h3>Breaks </h3>{" "}
                    {data.breakInfo.length < 5 && (
                      <span onClick={() => addBReaks(sfhtI)}>
                        <i className="fas fa-plus safetyAlert"></i> Add Break
                      </span>
                    )}
                  </div>

                  <table className="GeneratedTable">
                    <thead>
                      <tr>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Break Type</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.breakInfo.map((b, bI) => (
                        <tr key={bI}>
                          <td>
                            <span className="t-crd">
                              <NumberBox
                                width="70px"
                                value={b["startTime"] ? b["startTime"]["h"] : 9}
                                min={1}
                                max={12}
                                stylingMode="outlined"
                                showSpinButtons={true}
                                className="inBlk"
                                onValueChanged={(e) => {
                                  setShifts((prevData) => {
                                    return prevData.map((d, i) => {
                                      if (sfhtI == i) {
                                        d["breakInfo"][bI]["startTime"]["h"] =
                                          e.value;
                                        logBrkUpdate(sfhtI, bI);
                                      }

                                      return d;
                                    });
                                  });
                                }}
                              />

                              <span style={{ padding: "10px 5px" }}>:</span>
                              <NumberBox
                                width="70px"
                                stylingMode="outlined"
                                className="inBlk"
                                value={b["startTime"] ? b["startTime"]["m"] : 9}
                                min={0}
                                max={59}
                                step={5}
                                showSpinButtons={true}
                                onValueChanged={(e) => {
                                  setShifts((prevData) => {
                                    return prevData.map((d, i) => {
                                      if (sfhtI == i) {
                                        d["breakInfo"][bI]["startTime"]["m"] =
                                          e.value;
                                        logBrkUpdate(sfhtI, bI);
                                      }
                                      return d;
                                    });
                                  });
                                }}
                              />
                              <span> </span>
                              <SelectBox
                                items={["AM", "PM"]}
                                width="70px"
                                className="inBlk"
                                value={
                                  b["startTime"] ? b["startTime"]["mer"] : "AM"
                                }
                                onValueChanged={(e) => {
                                  setShifts((prevData) => {
                                    return prevData.map((d, i) => {
                                      if (sfhtI == i) {
                                        d["breakInfo"][bI]["startTime"]["mer"] =
                                          e.value;
                                        logBrkUpdate(sfhtI, bI);
                                      }
                                      return d;
                                    });
                                  });
                                }}
                              />
                            </span>
                          </td>
                          <td>
                            <span className="t-crd">
                              <NumberBox
                                width="70px"
                                value={b["endTime"] ? b["endTime"]["h"] : 9}
                                min={1}
                                max={12}
                                stylingMode="outlined"
                                showSpinButtons={true}
                                className="inBlk"
                                onValueChanged={(e) => {
                                  setShifts((prevData) => {
                                    return prevData.map((d, i) => {
                                      if (sfhtI == i) {
                                        d["breakInfo"][bI]["endTime"]["h"] =
                                          e.value;
                                        logBrkUpdate(sfhtI, bI);
                                      }
                                      return d;
                                    });
                                  });
                                }}
                              />
                              <span style={{ padding: "10px 5px" }}>:</span>
                              <NumberBox
                                width="70px"
                                stylingMode="outlined"
                                className="inBlk"
                                value={b["endTime"] ? b["endTime"]["m"] : 9}
                                min={0}
                                max={59}
                                step={5}
                                showSpinButtons={true}
                                onValueChanged={(e) => {
                                  setShifts((prevData) => {
                                    return prevData.map((d, i) => {
                                      if (sfhtI == i) {
                                        d["breakInfo"][bI]["endTime"]["m"] =
                                          e.value;
                                        logBrkUpdate(sfhtI, bI);
                                      }
                                      return d;
                                    });
                                  });
                                }}
                              />
                              <span> </span>
                              <SelectBox
                                items={["AM", "PM"]}
                                width="70px"
                                className="inBlk"
                                value={
                                  b["endTime"] ? b["endTime"]["mer"] : "AM"
                                }
                                onValueChanged={(e) => {
                                  setShifts((prevData) => {
                                    return prevData.map((d, i) => {
                                      if (sfhtI == i) {
                                        d["breakInfo"][bI]["endTime"]["mer"] =
                                          e.value;
                                        logBrkUpdate(sfhtI, bI);
                                      }
                                      return d;
                                    });
                                  });
                                }}
                              />
                            </span>
                          </td>
                          <td>
                            <TextBox
                              value={b.type}
                              maxLength={20}
                              onValueChanged={(e) => {
                                setShifts((prevData) => {
                                  return prevData.map((d, i) => {
                                    if (sfhtI == i) {
                                      d["breakInfo"][bI]["type"] = e.value;
                                      logBrkUpdate(sfhtI, bI);
                                    }
                                    return d;
                                  });
                                });
                              }}
                            />
                          </td>
                          <td>
                            <a
                              onClick={() => delBreak(sfhtI, bI)}
                              className="dx-link dx-link-delete dx-icon-trash dx-link-icon"
                            ></a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <>
                    {data.breakInfo.length == 0 && (
                      <h5 style={{ textAlign: "center", padding: "4px" }}>
                        No Breaks.
                      </h5>
                    )}
                  </>
                </div>
              </div>
            );
          })}
      </>
    );
  };

  return (
    <>
      <Popup
        visible={showShift}
        onHiding={() => closeShift(false)}
        dragEnabled={false}
        showCloseButton={true}
        showTitle={true}
        title={tierName}
        width={930}
        height={650}
      >
        <div>
          <button
            className={`tab-button ${
              activeTabHeader === "tab1" ? "active" : ""
            }`}
            onClick={() => setactiveTabHeader("tab1")}
            style={{ marginLeft: "1%" }}
          >
            Shift Schedule
          </button>
          <button
            className={`tab-button ${
              activeTabHeader === "tab2" ? "active" : ""
            }`}
            onClick={() => setactiveTabHeader("tab2")}
          >
            Material Configuration
          </button>
          <div className="tab-content">
            {activeTabHeader === "tab1" && (
              <div>
                <Tabs
                  dataSource={tabs}
                  selectedIndex={activeTab}
                  onOptionChanged={onTabChange}
                />
                <div className="shift-blk">
                  {shiftDetails && (
                    <>
                      <div className="w-20p"></div>
                      {activeTab == 1 ||
                      activeTab == 2 /*&& shiftDetails.isStdData*/ ? (
                        <div>
                          <div className="shift-blk" style={{ width: "100%" }}>
                            <div className="w-20p">
                              {activeTab == 1 && (
                                <>
                                  {config.DEV_DISPLAY_OPTIONS && <div className="dx-field shift-card">
                                    <div className="dx-field-label">
                                      DLE Target (%)
                                    </div>
                                    <NumberBox
                                      defaultValue={0}
                                      step={5}
                                      value={dleTarget}
                                      showSpinButtons={true}
                                      className="dx-field-value"
                                      min={0}
                                      max={100}
                                      onValueChanged={(e) => {
                                        userLog(e.value, "dleTarget");
                                        setDleTarget(e.value);
                                      }}
                                    />
                                    {/* <Validator><RequiredRule message="Target is required" /> </Validator> </NumberBox> */}
                                  </div> }

                                  {config.DEV_DISPLAY_OPTIONS && <div className="dx-field shift-card">
                                    <div className="dx-field-label">
                                      FPY Target (%)
                                    </div>
                                    <NumberBox
                                      defaultValue={0}
                                      step={5}
                                      value={fpyTarget}
                                      showSpinButtons={true}
                                      className="dx-field-value"
                                      min={0}
                                      max={100}
                                      onValueChanged={(e) => {
                                        userLog(e.value, "fpyTarget");
                                        setFPYTarget(e.value);
                                      }}
                                    />
                                    {/* <Validator><RequiredRule message="Target is required" /> </Validator> </NumberBox> */}
                                  </div> }

                                  { config.DEV_DISPLAY_OPTIONS && <div className="dx-field shift-card">
                                    <div className="dx-field-label">
                                      Sch. Attainment Target (%)
                                    </div>
                                    <NumberBox
                                      defaultValue={0}
                                      step={5}
                                      value={saTarget}
                                      showSpinButtons={true}
                                      className="dx-field-value"
                                      min={0}
                                      max={100}
                                      onValueChanged={(e) => {
                                        userLog(e.value, "saTarget");
                                        setSaTarget(e.value);
                                      }}
                                    />
                                    {/* <Validator><RequiredRule message="Target is required" /> </Validator> </NumberBox> */}
                                  </div> }

                                  <div className="dx-field shift-card">
                                    <div className="dx-field-label">
                                      OPH Attainment Target (%)
                                    </div>
                                    <NumberBox
                                      defaultValue={0}
                                      step={5}
                                      value={ophTarget}
                                      showSpinButtons={true}
                                      className="dx-field-value"
                                      min={0}
                                      max={100}
                                      onValueChanged={(e) => {
                                        userLog(e.value, "ophTarget");
                                        setophTarget(e.value);
                                      }}
                                    />
                                    {/* <Validator><RequiredRule message="Target is required" /> </Validator> </NumberBox> */}
                                  </div>
                                </>
                              )}

                              {activeTab == 2 && (
                                <>
                                  <div className="shift-card">
                                    <div style={{ padding: "8px 15px 9px 0" }}>
                                      Start date
                                    </div>{" "}
                                    <DateBox
                                      min={minDate}
                                      value={nSDate}
                                      onValueChanged={(e) => {
                                        postUserLog({
                                          event: "Shift Schedule Selection",
                                          data: {
                                            action: `NSPD dates selected to ${moment(
                                              e.value
                                            ).format("MM/DD/YYYY")} & ${moment(
                                              nSEndDate
                                            ).format("MM/DD/YYYY")}`,
                                            module: "Settings",
                                            section: "Manage Tier",
                                            siteUId: siteId,
                                            widget: "",
                                            tierId: `${tierId}`,
                                          },
                                        });
                                        setNSDate(e.value);
                                      }}
                                      useMaskBehavior={true}
                                      type="date"
                                      disabled={activeShiftData ? true : false}
                                    />
                                  </div>
                                  <div className="shift-card">
                                    <div style={{ padding: "8px 15px 9px 0" }}>
                                      End date
                                    </div>{" "}
                                    <DateBox
                                      min={minDate}
                                      value={nSEndDate}
                                      onValueChanged={(e) => {
                                        postUserLog({
                                          event: "Shift Schedule Selection",
                                          data: {
                                            action: `NSPD dates selected to ${moment(
                                              nSDate
                                            ).format("MM/DD/YYYY")} & ${moment(
                                              e.value
                                            ).format("MM/DD/YYYY")}`,
                                            module: "Settings",
                                            section: "Manage Tier",
                                            siteUId: siteId,
                                            widget: "",
                                            tierId: `${tierId}`,
                                          },
                                        });
                                        setNSEndDate(e.value);
                                      }}
                                      useMaskBehavior={true}
                                      type="date"
                                      disabled={activeShiftData ? true : false}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>

                          <div className="shift-head-blk">
                            {" "}
                            <h2>Shift details</h2>
                            {!activeShiftData && (
                              <span onClick={addShift}>
                                <i
                                  className="fas fa-plus safetyAlert"
                                  title="Add Shift"
                                ></i>{" "}
                                Add Shift
                              </span>
                            )}
                          </div>
                          <ScrollView
                            id="sitecontent"
                            {...{
                              showScrollbar: "always",
                              scrollByContent: true,
                              scrollByThumb: true,
                            }}
                            style={{ paddingbottom: "5px" }}
                          >
                            <div
                              className={activeShiftData ? "disbl-shift" : ""}
                              style={{
                                maxHeight: "270px",
                                paddingRight: "10px",
                              }}
                            >
                              {shiftScheduler()}
                              <div style={{ margin: "5px" }}>&nbsp;</div>
                              <>
                                {shifts.length == 0 && (
                                  <h3
                                    style={{
                                      textAlign: "center",
                                      padding: "44px",
                                    }}
                                  >
                                    No data.
                                  </h3>
                                )}
                              </>
                            </div>
                          </ScrollView>
                          <br />
                          <div className="shft-act-btns">
                            <div
                              className="dx-field"
                              style={{ width: "266px" }}
                            >
                              {!activeShiftData && (
                                <Button
                                  className="dx-field-value dx-button button-popup-save"
                                  text="Save"
                                  onClick={saveShiftInfo}
                                />
                              )}
                              <Button
                                style={{ marginRight: "6px" }}
                                className="dx-field-value dx-button "
                                text="Cancel"
                                onClick={() => closeShift(false)}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* activeTab == 1 && !shiftDetails.isStdData && (
                <h3 style={{ textAlign: "center" }}>
                  <br />
                  <br />
                  <br />
                  No data exist for Standard Production Day shift schedule.
                  <br />
                  Standard Production Day shift schedule is required to enter
                  data into Non-Standard Production Day.
                </h3>
                          )

                          */}
                    </>
                  )}

                  {activeTab == 0 && (
                    <>
                      {shiftListData && (
                        <DataGrid
                          id="shiftListGrid"
                          dataSource={shiftListData}
                          onEditingStart={onEditShiftInfo}
                          showBorders={true}
                          onRowRemoved={onRowRemoved}
                        >
                          <Editing
                            mode="row"
                            useIcons={true}
                            allowUpdating={true}
                            allowDeleting={(e) =>
                              e.row.data.shiftType != "Standard"
                            }
                          />
                          <Paging defaultPageSize={5} />
                          <Pager
                            visible={true}
                            allowedPageSizes={[5, 10, 20, 50]}
                            showPageSizeSelector={true}
                            showInfo={true}
                            showNavigationButtons={true}
                          />
                          <Column
                            dataField="tierShiftID"
                            caption="Schedule Id"
                            dataType="number"
                          ></Column>
                          <Column
                            dataField="shiftType"
                            caption="Schedule Type"
                            dataType="string"
                          ></Column>
                          <Column
                            dataField="shiftQuantity"
                            caption="No. of Shifts"
                          />

                          <Column dataField="startDate" caption="Start date" />
                          <Column dataField="endDate" caption="End date" />
                          <Column dataField="noofDays" caption="Days" />
                          <Column fixed={true} type="buttons" minWidth={110}>
                            <Button1
                              name="edit"
                              icon="info"
                              hint="View Shift Details"
                            />
                            <Button1 name="delete" />
                          </Column>
                        </DataGrid>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
            {activeTabHeader === "tab2" && (
              <div>
                <MaterialAddition
                  siteId={siteId}
                  tierId={tierId}
                  parentTier={parentTier}
                />
              </div>
            )}
          </div>
        </div>

        <Toast
          visible={toastConfig.isVisible}
          message={toastConfig.message}
          type={toastConfig.type}
          onHiding={() =>
            setToastConfig({
              ...toastConfig,
              isVisible: false,
            })
          }
          displayTime={1000}
        />
        <Position at="center" my="center" />
      </Popup>
    </>
  );
};
